<template>
	<div class="forget-password">
		<div class="step">
			<img src="../../../../common/assets/img/step_1.png">
		</div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="rule-form">
			<el-form-item prop="phoneNumber" :error="phoneError">
				<el-input
					type="text"
					@input="onPhoneInput"
					@blur="validatePhoneIfComplete"
					v-model="ruleForm.phoneNumber"
					auto-complete="off"
					maxlength="11"
					class="phoneNumber"
					placeholder="请输入手机号"
				></el-input>
			</el-form-item>
			<el-form-item prop="smsCode" style="position:relative;" :error="smsError" ref="smsCodeTest">
				<el-input
					type="text"
					v-model="ruleForm.smsCode"
					auto-complete="off"
					class="smsCode"
					placeholder="请输入短信验证码"
					maxlength="6"
				></el-input>
				<span @click="phonecodeAjax('ruleForm')" :class="{'smsBtn': canClick,'disabled': !canClick}">
					{{ smsText }}
				</span>
				<div class="smsTip" v-show="!canClick && !canShow">{{ smsTip }}</div>
			</el-form-item>
			<button @click="nextStep('ruleForm', $event)" class="next-btn">下一步</button>
		</el-form>
	</div>
</template>

<script>
// 使用 CDN 加载的 window.TAL_UC（npm import 可能为 undefined）
const Countdown = 60

function getTAL_UC() {
  return window.TAL_UC
}

export default {
	inject: ['showUdcSlider', 'hideUdcSlider'],
	data() {
		const checkPhone = (rule, value, callback) => {
			this.phoneFlag = false
			this.canClick = false
			if (!value) {
				callback(new Error('请输入手机号'))
			} else {
				const isPhone = /^(13|15|16|18|14|17|19)[0-9]{9}$/.test(value)
				const is11 = /^\d{11}$/.test(value)
				if (!is11) {
					callback(new Error('手机号由11位数字组成'))
				} else if (isPhone) {
					if (value === this.userPhone) {
						callback(new Error('手机号与账户当前绑定手机号相同，请更换手机号完成绑定'))
					} else {
						this.phoneFlag = true
						if (this.totalTime === Countdown || this.totalTime < 0) {
							this.canClick = true
						}
						callback()
					}
				} else {
					callback(new Error('不支持该手机号号段'))
				}
			}
		}

		const checkSMSCode = (rule, value, callback) => {
			if (!value && this.canShow) {
				callback(new Error('短信验证码不能为空'))
			} else if (!(value.length === 6 && /^[1-9]\d*|0$/.test(Number(value))) && this.canShow) {
				callback(new Error('短信验证码不正确'))
			} else {
				callback()
			}
		}

		return {
			smsError: '',
			phoneError: '',
			state: {
				phone: false
			},
			ruleForm: {
				phoneNumber: '',
				smsCode: ''
			},
			rules: {
				phoneNumber: [{ validator: checkPhone, trigger: 'blur' }],
				smsCode: [{ validator: checkSMSCode, trigger: 'blur' }]
			},
			userPhone: '',
			totalTime: Countdown,
			smsText: '获取短信验证码',
			canClick: false,
			clockFlag: null,
			canNextFlag: false,
			canShow: true,
			smsTip: '',
			phoneFlag: false
		}
	},
	watch: {
		phoneFlag: {
			handler(val) {
				if (val && (this.totalTime === Countdown || this.totalTime < 0)) {
					this.canClick = true
				}
			}
		}
	},
	methods: {
		onPhoneInput() {
            console.log(this.ruleForm.phoneNumber.length)
			this.state.phone = false
			if (this.ruleForm.phoneNumber.length === 11) {
				this.$nextTick(() => this.$refs.ruleForm.validateField('phoneNumber'))
			}
		},
		validatePhoneIfComplete() {
			if (this.ruleForm.phoneNumber.length === 11) {
				this.$refs.ruleForm.validateField('phoneNumber')
			}
		},
		initUdc() {
			const tryInit = (retries = 10) => {
				const TAL_UC = getTAL_UC()
				if (TAL_UC) {
					const ucEnv = process.env.NODE_ENV === 'production' ? 'production' : 'sandbox'
					TAL_UC.rankConfig({
						'client-id': '111101',
						env: ucEnv,
						loginout_callback: function(res) {
							console.log(res, '=== 未登录/登录失效统一处理回调方法 =======')
						}
					})
					TAL_UC.configNVC({
						renderToEle: '#captcha',
						isH5: false,
						language: 'cn'
					})
					return
				}
				if (retries > 0) {
					setTimeout(() => tryInit(retries - 1), 300)
				} else {
					console.warn('UDC SDK 加载超时')
				}
			}
			tryInit()
		},
		// 获取短信验证码
		phonecodeAjax(formName) {
			// if (!this.canClick) return
			this.$refs[formName].validateField('phoneNumber', (error) => {
				if (error) return
				this.canClick = false
				window.clearInterval(this.clockFlag)
				this.ruleForm.smsCode = ''
				this.phoneError = ''
				this.$refs['smsCodeTest'] && this.$refs['smsCodeTest'].clearValidate()

				const sendSMSCodeParams = {
					data: {
						phone: this.ruleForm.phoneNumber,
						phone_code: '86',
						use: 4
					},
					success: (res) => {
						if (res.errcode === 11021) {
							this.showUdcSlider('sendSMSCode', sendSMSCodeParams, (err) => {
								this.hideUdcSlider()
								this.$message.error((err && err.errmsg) || '滑块验证失败')
								this.canClick = this.phoneFlag && (this.totalTime === Countdown || this.totalTime < 0)
							})
							return
						}
						if (res.errcode === 0) {
							this.hideUdcSlider()
							this.totalTime = Countdown
							this.canShow = false
							this.smsTip = '由于运营商原因，手机短信可能会有延迟，请您耐心等待'
							this.smsText = this.totalTime + 's后重新发送'
							this.clockFlag = setInterval(() => {
								this.totalTime--
								this.smsText = this.totalTime + 's后重新发送'
								if (this.totalTime < 0) {
									this.canShow = true
									window.clearInterval(this.clockFlag)
									if (this.canNextFlag) {
										this.canClick = false
										this.canNextFlag = false
										this.smsText = '获取短信验证码'
										return
									}
									this.smsText = '重新发送验证码'
									this.canClick = this.phoneFlag
								}
							}, 1000)
						} else {
                            this.hideUdcSlider()
							this.phoneError = res.errmsg || res.data || '获取验证码失败'
							this.canClick = this.phoneFlag && (this.totalTime === Countdown || this.totalTime < 0)
						}
					},
					fail: (err) => {
                        this.hideUdcSlider()
						this.phoneError = (err && err.errmsg) || '获取验证码失败'
						this.canClick = this.phoneFlag && (this.totalTime === Countdown || this.totalTime < 0)
					}
				}
				const uc = getTAL_UC()
				if (!uc) {
					this.$message.error('验证服务未加载，请刷新重试')
					this.canClick = this.phoneFlag && (this.totalTime === Countdown || this.totalTime < 0)
					return
				}
				uc.sendSMSCode(sendSMSCodeParams)
			})
		},
		// 下一步 - 校验手机号+验证码
		nextStep(formName, event) {
			this.smsTip = ''
			this.canShow = true
			event.preventDefault()
			this.$refs[formName].validate((valid) => {
				if (!valid) return
				this.smsError = ''

				const checkPhoneParams = {
					data: {
						phone: this.ruleForm.phoneNumber,
						phone_code: '86',
						vcode: this.ruleForm.smsCode,
						type: 4
					},
					success: (res) => {
						if (res.errcode === 11021) {
							this.showUdcSlider('checkPhone', checkPhoneParams, (err) => {
								this.hideUdcSlider()
								this.$message.error((err && err.errmsg) || '滑块验证失败')
							})
							return
						}
						if (res.errcode === 0) {
							this.hideUdcSlider()
							this.$emit('showSetPass', {
								step: 2,
								phone: this.ruleForm.phoneNumber,
								phone_code: '86',
								tag: res.data && res.data.tag
							})
						} else {
							this.canNextFlag = true
							this.smsError = res.errmsg || '短信验证码不正确'
							this.ruleForm.smsCode = ''
							if (this.totalTime <= 0 && !this.canClick) {
								this.smsText = '获取短信验证码'
							}
						}
					},
					fail: (err) => {
						this.smsError = (err && err.errmsg) || '校验失败'
					}
				}
				const uc = getTAL_UC()
				if (!uc) {
					this.$message.error('验证服务未加载，请刷新重试')
					return
				}
				uc.checkPhone(checkPhoneParams)
			})
		}
	},
	mounted() {
		this.initUdc()
	}
}
</script>

<style lang='less'>
.forget-password {
	.step {
		overflow: hidden;
		text-align: center;
		margin: 90px 0;
	}
	.rule-form {
		width: 380px;
		margin: 0 auto;
		.el-form-item {
			margin-bottom: 32px;
			.el-form-item__error {
				line-height: 20px;
				color: #f00;
			}
			.el-input {
				height: 48px;
				.el-input__inner {
					height: 100%;
					line-height: 48px;
					color: #666;
					border: 1px solid #ccc;
				}
				.el-input__inner::-webkit-input-placeholder {
					color: #999;
				}
			}
			.el-form-item__content {
				line-height: 48px;
			}
		}
		.phone-user {
			margin-bottom: 30px;
		}
		.smsTip {
			font-size: 12px;
			color: #666666;
			width: 380px;
			height: 30px;
			position: absolute;
			left: 0;
			line-height: 30px;
		}
		.el-form-item {
			.code {
				width: 230px;
			}
			.smsCode {
				width: 230px;
			}
			.phon-btn {
				position: absolute;
				width: 136px;
				height: 47px;
				line-height: 47px;
				border-radius: 3px;
				color: #fff;
				text-align: center;
				font-size: 16px;
				right: 7px;
				top: 0px;
				z-index: 1;
			}
			.disabled {
				.phon-btn;
				background-color: #ddd;
				border-color: #ddd;
				cursor: not-allowed;
			}
			.smsBtn {
				.phon-btn;
				background: rgb(55, 188, 155);
				cursor: pointer;
			}
		}
		.next-btn {
			background-color: #f13233;
			width: 100%;
			height: 50px;
			font-size: 14px;
			border: 0;
			color: #fff;
			cursor: pointer;
			border-radius: 3px;
			&:hover {
				background-color: #fa4747;
				color: #fff;
			}
			&.el-button:hover {
				background-color: #fa4747;
				color: #fff;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// module/forgetPassword/src/components/setOne.vue